import React, { useEffect, useRef, useState } from 'react';
import CssHelper from 'Services/Utils/Css/CssHelper';
import styles from './Text.module.sass';

const Tooltip = React.lazy(() => import('../Tooltip/Tooltip'));

const Text = ({
    children,
    color, weight, transform, tooltip
}: Props) => {
    const innerRef: any = useRef();
    const [state, setState] = useState({
        isTruncated: false,
        showTooltip: false
    });

    useEffect(() => {
        const scrollWidth = innerRef?.current?.scrollWidth + 10;
        const offsetWidth = innerRef?.current?.offsetWidth;
        if (scrollWidth > offsetWidth) {
            setState(() => ({
                ...state,
                isTruncated: true
            }));
        }
    }, []);

    const handleTooltip = (value: boolean) => () => setState(() => ({
        ...state,
        showTooltip: value
    }));

    return <div
        className={CssHelper.createCssClass(`
            ${styles['text']}
            ${styles['text__color--'+(color??'inherit')]}
            ${styles['text__transform--'+(transform??'inherit')]}
            ${styles['text__weight--'+(weight??'inherit')]}
        `)}
        ref={innerRef}
        onMouseOver={handleTooltip(true)}
        onMouseLeave={handleTooltip(false)}
    >
        { children }
        {
            state.isTruncated &&
            state.showTooltip &&
            <Tooltip ref={innerRef?.current}>
                { tooltip ?? children }
            </Tooltip>
        }
    </div>
}

interface Props {
    children: any
    tooltip?: any
    color?: 'primary' | 'secondary' | 'inherit'
    weight?: 'bold' | 'semibold' | 'inherit'
    transform?: 'uppercase' | 'inherit'
}

export default Text;